<template>
  <v-row>
    <v-col cols="12" sm="12">
      <v-card>
        <v-card-title>{{ getPageTitle() }}</v-card-title>
        <v-divider></v-divider>

        <!-- Tag Filter Section -->
        <v-card-text v-if="tags.length > 0">
          <div class="mb-3">
            <v-chip class="ma-1" :color="selectedTagId === null ? 'primary' : 'default'"
              :outlined="selectedTagId !== null" @click="clearTagFilter" clickable>
              {{ t('Kaikki') }}
            </v-chip>
            <v-chip v-for="tag in tags" :key="tag.id" class="ma-1"
              :color="selectedTagId === tag.id ? 'primary' : 'default'" :outlined="selectedTagId !== tag.id"
              @click="filterByTag(tag.id)" clickable>
              {{ tag.title }}
            </v-chip>
          </div>
        </v-card-text>

        <newslist :news="news"></newslist>
        <div class="d-flex align-end flex-column mt-3" v-if="pages > 1">
          <v-pagination v-model="page" :length="pages" :total-visible="8"></v-pagination>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { useTranslations } from "@/@core/libs/i18n";
import api from "@/api";
import useAuth from "@/useAuth";
import { getDateTime } from "@/@core/utils/datetime_helpers";
import newslist from "@/components/news/newslist.vue";
import { i18n } from "@/plugins/i18n";
import useMenus from "@/@core/utils/useMenus";

export default {
  components: {
    newslist,
  },
  setup() {
    const page = ref(1);
    const totalCount = ref(0);
    const pageSize = 10;
    const news = ref([]);
    const tags = ref([]);
    const selectedTagId = ref(null);
    const { t } = useTranslations();
    const { tenant } = useAuth();
    const { getTenantTerm } = useMenus();

    const fetchNews = async () => {
      const response = await api.getNewsList(page.value, pageSize, selectedTagId.value);

      if (response.ok) {
        news.value = response.data.results;
        totalCount.value = response.data.count;
      } else {
        alert(response.error);
      }
    };

    const fetchTags = async () => {
      const response = await api.getTags();

      if (response.ok) {
        tags.value = response.data.results || response.data;
      } else {
        console.error("Error fetching tags:", response.error);
      }
    };

    const filterByTag = (tagId) => {
      if (selectedTagId.value == tagId) {
        clearTagFilter();
      }
      else {
        selectedTagId.value = tagId;
        page.value = 1; // Reset to first page when filtering
      }
      fetchNews();
    };

    const clearTagFilter = () => {
      selectedTagId.value = null;
      page.value = 1; // Reset to first page when clearing filter
      fetchNews();
    };

    watch(page, () => {
      fetchNews();
    });

    onMounted(() => {
      fetchNews();
      if (tenant.value.settings.tags_enabled)
        fetchTags();
    });

    const pages = computed(() => {
      return Math.ceil(totalCount.value / pageSize);
    });

    const getImage = (n) => {
      if (Object.keys(n.image).length) {
        return n.image.thumbnail;
      }
      return tenant.value.logo.thumbnail;
    };

    const getPageTitle = () => {
      const tenantTerm = getTenantTerm(
        "news",
        tenant.value.terms?.translations,
        i18n.locale
      );
      return tenantTerm ?? t("Uutiset");
    };

    return {
      getPageTitle,
      page,
      totalCount,
      news,
      pages,
      getImage,
      getDateTime,
      t,
      tags,
      selectedTagId,
      filterByTag,
      clearTagFilter,
    };
  },
};
</script>

<style></style>
